import React, { Fragment } from 'react'
import AntGlobal from './ant-design'
import AtnMotionGlobal from './ant-design-motion'
import CommonGlobal from './common'

export default () => (
  <Fragment>
    <AntGlobal />
    <AtnMotionGlobal />
    <CommonGlobal />
  </Fragment>
)
